export default __webpack_public_path__ + "13af4ef7ccb99a13a9a535669985ad50.png";